import * as React from 'react';
import * as _ from 'underscore';

import {
  CardPositionContext,
  ContentInfoContext,
} from '../../app/contexts/TelemetryContexts';
import { ConnectedContentCardWrapper } from '../../app/spaces/CardView/ConnectedContentCardWrapper';
import { SpaceInfo } from '../../app/state/SpaceInfo';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ChannelStyles } from '../styles/ChannelStyles';
import { ChannelTypes } from '../types/ChannelTypes';
import { Channel } from './Channel';

export interface ContentInfoChannelBaseProps {
  readonly channelType: ChannelTypes;
  readonly title: string;
  readonly list: ReadonlyArray<IContentInfo>;
  readonly seeAllUrl: string;
  readonly seeAllAltText: string;
  readonly showLastAccessedAt?: boolean;
  readonly isFetching: boolean;
  readonly maxCardsPerRow: number;
  readonly numRows: number;
  readonly spaceInfo: SpaceInfo;
}

export interface ContentInfoChannelOwnProps {
  readonly maxCardsPerRow: number;
}

export type ContentInfoChannelProps = ContentInfoChannelBaseProps & ContentInfoChannelOwnProps;

export class ContentInfoCardChannel extends React.PureComponent<ContentInfoChannelProps> {

  render() {
    const maxNumCards = this.props.maxCardsPerRow * this.props.numRows;
    let cards = this.props.list.slice(0, maxNumCards).map((contentInfo: IContentInfo, id: number) => {
        return (
          <React.Fragment key={`${contentInfo.contentType}:${contentInfo.id}:${this.props.channelType}`}>
            <ContentInfoContext.Provider value={contentInfo}>
              <CardPositionContext.Provider value={id + 1}>
                <div className={ChannelStyles.cardDimensions}>
                  <ConnectedContentCardWrapper
                    content={contentInfo}
                    showActionMenu={true}
                    showLastAccessedAt={this.props.showLastAccessedAt}
                    forDragPreview={false}
                    dragInProgress={false}
                    setIsDragging={_.noop}
                  />
                </div >
              </CardPositionContext.Provider>
            </ContentInfoContext.Provider>
          </React.Fragment>
        );
    });

    return (
      <Channel {...this.props}>{cards}</Channel>
    );
  }
}
